<template>
  <v-autocomplete
    :items="items"
    v-model="selectedSupplier"
    label="Supplier"
    item-text="name"
    :item-value="itemValue"
    :clearable="clearable"
    @click:clear="clear"
    :outlined="outlined"
    :hide-details="hideDetails"
    @input="onInput"
    :disabled="disabled"
  ></v-autocomplete>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../helpers";
const SUPPLIERS_LIST = gql`
  query allSuppliersNames($filter: SupplierFilterType) {
    suppliers(filter:$filter) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
export default {
  name: "travel-list-select",
  props: {

    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    clearable: {
      type: Boolean,
      default: () => false,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
    itemValue: {
      type: String,
      default: () => "id",
    },
  },

  data() {
    return {
      debug: false,
      selectedSupplier: this.value,
      // search: null,
      // searchTimeout: null,
      // searchDebounceTime: 700,
      // nameFilter: null,
    };
  },

  computed: {
    items() {
      return this.suppliers && this.suppliers.edges
        ? this.suppliers.edges.map(removeGQLTypename)
        : [];
    },
  },
  watch: {
    value(newVal) {
      this.selectedSupplier = newVal;
    },
  },

  methods: {
    clear() {
      this.$emit("clear");
      this.$emit("onClear");
    },
    onInput(data) {
      this.$emit("input", data);
    },
  },

  apollo: {
    suppliers: {
      query: SUPPLIERS_LIST,
      variables() {
        return {
          filter: {service_type:'TRAVEL'},
        };
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/TravelListSelect.vue